import { Text, useBreakpointValue } from "@chakra-ui/react";

import { IconExperience, IconLanguages } from "../../styles/icons";
import { useMemo } from "react";
import Head from "next/head";

export const ViewSectionAbout = (props) => {
  const { aboutMe, practiceStartDate, languages } = props.profile;

  const titleTxtStyle = useBreakpointValue({ base: "h3mobile", md: "h3" });
  const bodyTxtStyle = useBreakpointValue({ base: "body2mobile", md: "body2" });

  const yearsExperience = useMemo(() => {
    let years =
      new Date().getFullYear() - new Date(practiceStartDate).getFullYear();
    return years > 0 && new Date(practiceStartDate).getFullYear() > 0
      ? `${years} years`
      : "Under 1 year";
  }, [practiceStartDate]);

  const languageList = useMemo(() => {
    const englishSelected = languages.filter(
      (elem) => elem.label === "English"
    ).length;
    let str;

    if (!languages.length) {
      str = "English";
    } else {
      if (!englishSelected) {
        str = `English${languages.length > 1 ? ", " : " and "}${languages
          ?.map((language) => language.label)
          .join(", ")}`;
      } else {
        str = languages?.map((language) => language.label).join(", ");
      }
    }
    return str;
  }, [languages]);

  const decodedAbout = useMemo(() => {
    const isServer = typeof window === "undefined";
    if (isServer) {
      return aboutMe;
    }
    const decodeElement = document.createElement("div");
    let text = aboutMe;

    if (text && typeof text === "string") {
      text = text.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, "");
      text = text.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, "");
      decodeElement.innerHTML = text;
      text = decodeElement.textContent;
      decodeElement.textContent = "";
    }

    return text;
  }, [aboutMe]);

  // Render
  return (
    <div className="relative flex flex-col p-[30px] gap-5">
      <Head>
        <meta name="description" content={decodedAbout} />
        <meta name="og:description" content={decodedAbout} />
      </Head>
      <div className="flex flex-col gap-5">
        <Text textStyle={titleTxtStyle}>About me</Text>
        <div className="flex flex-nowrap">
          <Text textStyle={bodyTxtStyle} sx={{ whiteSpace: "pre-line" }}>
            {decodedAbout}
          </Text>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row items-start sm:items-center w-full gap-2 sm:gap-[30px]">
        {practiceStartDate && (
          <div className="flex items-center w-max">
            <IconExperience className="h-5 w-5 mr-2" />
            <p className="font-bold text-nowrap">{yearsExperience}</p>
            <p className="text-nowrap">&nbsp;of experience</p>
          </div>
        )}
        <div className="flex items-center w-max">
          <IconLanguages className="h-5 w-5 mr-2" />
          <p className="text-nowrap">Speaks</p>
          <p className="font-bold text-nowrap">&nbsp;{languageList}</p>
        </div>
      </div>
    </div>
  );
};
